import React, { Component } from "react"

class Checkbox extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isChecked: props.checked,
        }
    }

    toggleCheckboxChange = () => {
        this.setState({
            isChecked: !this.state.isChecked,
        })
        this.props.childChange(this.props.value)
    }

    render() {
        return (
            <div className="form__checkbox">
                <label>
                    <input
                        type="checkbox"
                        value={this.props.value}
						//checked={this.state.isChecked}
						checked={this.props.checked}
                        onChange={this.toggleCheckboxChange}
                    />
                    {this.props.label}
                </label>
            </div>
        )
    }
}

export default Checkbox
